module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      list: !_vm.isontop, listTop: _vm.isontop
    }
  }, [_c('ul', {
    staticClass: "lnav clearfix"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.shownav(0, 'pop')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.h1
    }
  }, [_c('span', {
    class: {
      active: _vm.isshownav == 0
    }
  }, [_vm._v("流行")])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.shownav(1, 'sell')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.h2
    }
  }, [_c('span', {
    class: {
      active: _vm.isshownav == 1
    }
  }, [_vm._v("新款")])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.shownav(2, 'new')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.h3
    }
  }, [_c('span', {
    class: {
      active: _vm.isshownav == 2
    }
  }, [_vm._v("精选")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-694a57fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-694a57fa","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/plist.vue
// module id = 137
// module chunks = 0